import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EnglishDisclaimerService {
  private showMessage = new BehaviorSubject<boolean>(false);
  showMessage$ = this.showMessage.asObservable();

  public setShowMessage(value) {
    this.showMessage.next(value);
  }
}
